import React, { FC } from 'react';
import { Form, Modal as AntModal } from 'antd';

type Props = {
  title: string;
  ModalForm: any;
  bindActionButtons?: boolean;
  visible: boolean;
  dismiss: Function;
  onSubmit: Function;
  value: any;
};

const EditModal: FC<Props> = ({ title, visible, dismiss, onSubmit, ModalForm, bindActionButtons = false, value }) => {
  const [form] = Form.useForm();

  return (
    <>
      <AntModal
        title={title}
        visible={visible}
        {...(bindActionButtons
          ? {
            okText: 'Edit',
            onOk: () => {
              form
                .validateFields()
                .then(async values => {
                  const success = await onSubmit(values);
                  if (success) {
                    form.resetFields();
                    dismiss(false);
                  }
                })
                .catch(info => {
                  console.log('Validate Failed:', info);
                });
            }
          }
          : {
            footer: null
          })}
        onCancel={() => dismiss()}
      >
        <ModalForm
          {...(bindActionButtons ? { form } : { onSubmit, closeModal: () => dismiss() })}
          layout={'horizontal'}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
          value={value}
        />
      </AntModal>
    </>
  );
};

export default EditModal;
